import { WorkoutType } from './workout.domain';
import { WorkoutsTabHash } from '../../collection/domain';
import { navigate, PATHS } from '@client/paths';

const getProgramWokroutTab = ({
  archivedAt,
  publishedAt,
}: {
  archivedAt?: string;
  publishedAt?: string;
}): WorkoutsTabHash => {
  if (archivedAt) return 'workouts-archived';
  if (publishedAt) {
    return new Date(publishedAt).getTime() > new Date().getTime()
      ? 'workouts-scheduled'
      : 'workouts-published';
  }
  return 'workouts-draft';
};

export const redirectFromWorkouts = ({
  archivedAt,
  publishedAt,
  programId,
  influencerId,
  ...p
}: {
  programId?: string;
  influencerId: number;
  archivedAt?: string;
  publishedAt?: string;
  workoutId?: number;
  workoutType?: WorkoutType;
}) => {
  if (p.workoutId && programId) {
    const path = PATHS.WORKOUT_EDIT({
      workoutId: p.workoutId,
      influencerId,
      programId: parseInt(programId, 10),
      workoutType: p.workoutType,
    });
    return navigate(path);
  }
  if (programId) {
    const workoutsTab = getProgramWokroutTab({
      archivedAt,
      publishedAt,
    });
    return workoutsTab
      ? navigate(
          `${PATHS.CATEGORY_EDIT(
            Number(programId),
            influencerId,
          )}#${workoutsTab}`,
        )
      : navigate(PATHS.CATEGORY_EDIT(Number(programId), influencerId));
  }
  if (archivedAt)
    return navigate(PATHS.PARTNER_WORKOUTS_ARCHIVED(influencerId));
  if (publishedAt) {
    return new Date(publishedAt).getTime() > new Date().getTime()
      ? navigate(PATHS.PARTNER_WORKOUTS_SCHEDULED(influencerId))
      : navigate(PATHS.PARTNER_WORKOUTS_PUBLISHED(influencerId));
  }
  return navigate(PATHS.PARTNER_WORKOUTS_DRAFTS(influencerId));
};
